import { render, staticRenderFns } from "./CustomerTimeline.vue?vue&type=template&id=3b6c3649"
import script from "./CustomerTimeline.vue?vue&type=script&lang=js"
export * from "./CustomerTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports